import type { EditableCallbackParams } from "ag-grid-enterprise";

type Props = EditableCallbackParams;

export const DocumentNameColumn = ({ data }: Props) => {
	return data?.DocumentName;
};
